import { postDataSecurityAlertsExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAlertsExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAlertsExport',
	receive: true,
	request: true,
	requestHandler: postDataSecurityAlertsExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
